<svg viewBox="0 0 100 63" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="99" height="62" rx="3.5" fill="black" fill-opacity="0.03"/>
    <path d="M51 38.5V32.5H57V30.5H51V24.5H49V30.5H43V32.5H49V38.5H51Z" fill="white"/>
    <rect x="0.5" y="0.5" width="99" height="62" rx="3.5" stroke="url(#paint0_linear_2751_146422)" stroke-dasharray="8 3"/>
    <defs>
        <linearGradient id="paint0_linear_2751_146422" x1="50" y1="1" x2="50" y2="62" gradientUnits="userSpaceOnUse">
            <stop stop-opacity="0.05"/>
            <stop offset="1" stop-opacity="0.14"/>
        </linearGradient>
    </defs>
</svg>
